// @flow
import { connect } from 'react-redux'
import TargetingSources from './TargetingSources'
import type { Store } from '../redux/ducks'
import type { State as AudienceState } from '../redux/ducks/audienceEdit/reducers'
import { patch } from './AudienceEditContainer'
import postJson from '../services/postJson'
import _ from 'lodash'
import store from '../redux/store'
import { translateFunc, translations } from '../shared/localize'

const createProviderTargetingSourcesUrl = '/api/v1/provider_targeting_sources'

function mapStateToProps(state: Store) {
  const audienceState = state.audienceEdit
  const initial = audienceState.initial

  if (!initial) return {}

  return {
    contactTypeTranslations: initial.targetingSources.contactTypeTranslations,
    includedSegmentIds: audienceState.includedSegmentIds,
    excludedSegmentIds: audienceState.excludedSegmentIds,
    includedContactIds: audienceState.includedContactIds,
    excludedContactIds: audienceState.excludedContactIds,
    includedLookalikeSegmentIds: audienceState.includedLookalikeSegmentIds,
    includedLookalikeContactIds: audienceState.includedLookalikeContactIds,
    includedProviderTargetingSourceIds: audienceState.includedProviderTargetingSourceIds,
    excludedProviderTargetingSourceIds: audienceState.excludedProviderTargetingSourceIds,
    segments: audienceState.segments,
    contacts: audienceState.contacts,
    lookalikeSegments: audienceState.lookalikeSegments,
    lookalikeContacts: audienceState.lookalikeContacts,
    providerTargetingSources: audienceState.providerTargetingSources,
    countries: audienceState.countries,
    defaultCountryId: audienceState.defaultCountryId,
    includedSegmentIdsErrors: audienceState.includedSegmentIdsErrors,
    includedContactIdsErrors: audienceState.includedContactIdsErrors,
    excludedSegmentIdsErrors: audienceState.excludedSegmentIdsErrors,
    excludedContactIdsErrors: audienceState.excludedContactIdsErrors,
    includedLookalikeSegmentIdsErrors: audienceState.includedLookalikeSegmentIdsErrors,
    includedLookalikeContactIdsErrors: audienceState.includedLookalikeContactIdsErrors,
    includedProviderTargetingSourceIdsErrors:
      audienceState.includedProviderTargetingSourceIdsErrors,
    excludedProviderTargetingSourceIdsErrors:
      audienceState.excludedProviderTargetingSourceIdsErrors,
    icons: initial.targetingSources.icons
  }
}

function mapDispatchToProps(dispatch: Function, ownProps) {
  return {
    onChange: (diff: $Shape<AudienceState>) => {
      patch(dispatch, diff)
      ownProps && ownProps.onChange()
    },
    onImportProviderTargetingSources: (provider: string) => {
      const t = translateFunc(translations.targeting_sources)

      postJson(createProviderTargetingSourcesUrl, { data: { provider: provider } })
        .done((response) => {
          if (_.isEmpty(response.data)) {
            window.alert(t('nothing_to_import'))
            return
          }

          const state = store.getState()
          const audienceState = state.audienceEdit
          patch(dispatch, {
            providerTargetingSources: _.concat(
              audienceState.providerTargetingSources,
              ...response.data
            )
          })
          window.alert(t('import_success'))
        })
        .fail(() => window.alert('Internal error'))
    }
  }
}

const TargetingSourcesContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(TargetingSources)

export default TargetingSourcesContainer
